import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'

import FormatCurrency from 'components/Common/FormatCurrency'
import { pluralizeToString } from 'lib/string/pluralize'
import Caption from 'components/Luxkit/Typography/Caption'
import Heading from 'components/Luxkit/Typography/Heading'
import StructureLabel from 'components/Luxkit/Label/StructureLabel'
import RadioButtonInput from 'components/Luxkit/RadioButton/RadioButtonInput'
import InlineGroup from 'components/Common/InlineGroup'
import { Divider } from '../../Shared/Divider'
import { mediaQueryUp } from 'components/utils/breakpoint'

const StyledInlineGroup = styled(InlineGroup)`
  margin-top: ${rem(12)};
  margin-bottom: ${rem(12)};
`

const StyledBonusInclusionsLabel = styled(StructureLabel)`
  margin-top: ${rem(4)};

  ${mediaQueryUp.tablet} {
    margin-top: 0;
    margin-left: ${rem(8)};
  }
`

const StyledTotalCaption = styled(Caption)`
  margin-left: ${rem(4)};
`

const NightsAndBonusInclusionsContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaQueryUp.tablet} {
    flex-direction: row;
  }
`

interface Props {
  bonusInclusions: boolean;
  checked: boolean;
  name: number;
  nights: number;
  onSwitchPackageDuration: (e: React.ChangeEvent<HTMLInputElement>) => void;
  price: number;
}

export function BnblSwitchPackageDurationItem({ bonusInclusions, checked, name, nights, onSwitchPackageDuration, price }: Props) {
  return (
    <>
      <StyledInlineGroup horizontal="between" vertical="center">
        <RadioButtonInput
            checked={checked}
            name={String(name)}
            onChange={onSwitchPackageDuration}
          >
          <NightsAndBonusInclusionsContainer>
            <div>
              {pluralizeToString('night', nights)}
            </div>
            <div>
              {bonusInclusions && <StyledBonusInclusionsLabel variant="standard">Bonus inclusions</StyledBonusInclusionsLabel>}
            </div>
          </NightsAndBonusInclusionsContainer>
        </RadioButtonInput>

        <div>
          <InlineGroup horizontal="end">
            <Caption colour="neutral-three" variant="medium">From</Caption>
          </InlineGroup>
          <InlineGroup vertical="center">
            <Heading variant="heading6">
              <FormatCurrency value={price} format="preciseDollar" />
            </Heading>
            <StyledTotalCaption colour="neutral-three" variant="medium">total</StyledTotalCaption>
          </InlineGroup>
        </div>
      </StyledInlineGroup>
      <Divider />
    </>
  )
}
